import { UPLOADS_ENDPOINTS } from "./endpoints/uploadsEndpoints";
import { AUTH_ENDPOINTS } from "./endpoints/authEndpoints";
import { PAYMENT_ENDPOINTS } from "./endpoints/paymentsEndpoints";
import { PRODUCT_ENDPOINTS } from "./endpoints/productsEndpoints";
import { PROFILES_ENDPOINTS } from "./endpoints/profilesEndpoints";
import { D1Database, Fetcher, KVNamespace, R2Bucket } from "@cloudflare/workers-types";
import { ORDERS_ENDPOINTS } from "./endpoints/ordersEndpoints";
import { SCRAPER_ENDPOINTS } from "./endpoints/scraperEndpoints";

// Re-export individual endpoint files (optional but useful)
export * from "./endpoints/authEndpoints";
export * from "./endpoints/productsEndpoints";
export * from "./endpoints/profilesEndpoints";
export * from "./endpoints/uploadsEndpoints";
export * from "./endpoints/ordersEndpoints";
export * from "./endpoints/scraperEndpoints";

// export * from "../ORDER_CONSTANTS";

// constants
export * from "./constants";

// types
export * from "./types";

// Combined endpoints object
export const MY_ENDPOINTS = {
  AUTH_ENDPOINTS,
  PROFILES_ENDPOINTS,
  PRODUCT_ENDPOINTS,
  PAYMENT_ENDPOINTS,
  UPLOADS_ENDPOINTS,
  ORDERS_ENDPOINTS,
  SCRAPER_ENDPOINTS
};

